import { createFileRoute, redirect } from '@tanstack/react-router'

// Back-compat: the standalone 3D car demo was retired. Send legacy links home.
export const Route = createFileRoute('/car')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
